export const shouldDisableUsername = (showSuccess, tempPassword, isValid) => {
  return showSuccess || tempPassword || !isValid;
};
